import React, { type ReactNode } from 'react';
import styled from 'styled-components';

// Breakpoints
const MOBILE_BREAKPOINT = '900px';

// Styled components for the layout
const Layout = styled.div`
  display: flex;
  gap: 24px;
  height: 100%;
  width: 100%;
  overflow-y: auto; // Enable vertical scrolling for both columns together
  overflow-x: hidden; // Prevent horizontal scrolling

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    flex-direction: column;
  }
`;

const MainContentColumn = styled.div`
  flex: 1;
  min-width: 0; // Prevents flex items from overflowing
  display: flex;
  flex-direction: column;
  padding: 16px;
  border-radius: 8px;
  height: fit-content; // Allow content to determine height

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    height: auto;
  }
`;

const MainContentInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const SidebarColumn = styled.div`
  width: 320px;
  flex-shrink: 0;
  padding: 16px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  height: fit-content; // Allow content to determine height

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    width: 100%;
    height: auto;
  }
`;

interface TaskLayoutProps {
  main: ReactNode;
  sidebar: ReactNode;
}

const TaskLayout: React.FC<TaskLayoutProps> = ({ main, sidebar }) => {
  return (
    <Layout>
      <MainContentColumn>
        <MainContentInner>{main}</MainContentInner>
      </MainContentColumn>
      <SidebarColumn>{sidebar}</SidebarColumn>
    </Layout>
  );
};

export default TaskLayout;
export { MainContentInner, MOBILE_BREAKPOINT };
